import { render, staticRenderFns } from "./GdprNotice.vue?vue&type=template&id=19fa79e0"
import script from "./GdprNotice.vue?vue&type=script&lang=js"
export * from "./GdprNotice.vue?vue&type=script&lang=js"
import style0 from "./GdprNotice.vue?vue&type=style&index=0&id=19fa79e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports